import { cva } from 'class-variance-authority';

export type RegionSelectVariant = 'primary' | 'dark';

const regionSelectItemTextVariants = cva(
	'text-start text-base font-normal leading-normal',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const regionSelectItemSubTextVariants = cva(
	'text-start text-xs font-normal leading-normal',
	{
		variants: {
			variant: {
				primary: 'text-primary-light-2',
				dark: 'text-white-dark-4'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

export function getRegionSelectStyles(variant: RegionSelectVariant) {
	return {
		itemText: regionSelectItemTextVariants({ variant }),
		itemSubText: regionSelectItemSubTextVariants({ variant })
	};
}
